import React, { useCallback, useEffect, useState } from 'react';

import { Input } from 'reactstrap';
import {
   cityInput$,
   stateInput$,
   zipInput$,
} from 'ui/util/rxjs/observables';
import './index.css';

const ReduxAddressInputAutosuggest = (props) => {
   const [autocomplete, setAutocomplete] = useState(null);

   const handleSelect = useCallback(() => {
      if (!autocomplete) {
         return null;
      }

      const place = autocomplete.getPlace();

      const addressComponents = place.address_components;

      let city = '', state = '', zip = '', latitude = '', longitude = '';

      if (place && place.geometry && place.geometry.location) {
         latitude = place.geometry.location.lat();
         longitude = place.geometry.location.lng();
      }

      let addressParts = [];
      for (const { long_name: longName, short_name: shortName, types } of addressComponents) {
         const type = types && types[0] ? types[0] : '';

         if (type === 'street_number' || type === 'route') {
            addressParts.push(shortName);
         } else if (type === 'locality') {
            city = longName;
         } else if (type === 'administrative_area_level_1') {
            state = shortName;
         } else if (type === 'postal_code') {
            zip = longName;
         }
      }

      const address = addressParts.join(' ');
      if (props.input.onChange) {
         props.input.onChange(address);
      }
      if (props.onLatLongUpdate) {
         props.onLatLongUpdate({ latitude, longitude });
      }

      cityInput$.next(city);
      stateInput$.next(state);
      zipInput$.next(zip);
   }, [autocomplete]);

   useEffect(() => {
      if (window.google && autocomplete === null) {
         const googleAutocomplete = new window.google.maps.places.Autocomplete(document.getElementById('LocationAutoComplete'), {
            types: ['address'],
            componentRestrictions: { country: 'us' },
         });
         // googleAutocomplete.setFields(["address_component"]);
         googleAutocomplete.addListener('place_changed', handleSelect);
         setAutocomplete(googleAutocomplete);
      } else if (autocomplete) {
         autocomplete.addListener('place_changed', handleSelect);
      }
   }, [handleSelect]);

   return (
      <Input
         id='LocationAutoComplete'
         type='text'
         {...props.input}
         valid={props.meta.touched && !props.meta.error}
         className={props.meta.touched && props.meta.error ? ' is-invalid ' : ''}
      />
   );
};

export default ReduxAddressInputAutosuggest;
